/**
 * Collapses every "not usably configured" case to undefined: envsubst renders an omitted
 * variable as "", a typo can render as bare slashes, and a whitespace value is truthy but
 * unusable. Trim before stripping slashes — the $ anchor cannot reach past trailing whitespace.
 */
export function normalizeBaseUrl(value: string | undefined): string | undefined {
  return value?.trim().replace(/\/+$/, "") || undefined;
}
